<template>
  <PageLayout>
    <div class="d-flex align-center justify-space-between">
      <h2 class="text-h3 font-weight-bold pb-4">
        Reklamy
      </h2>

      <v-btn small rounded text color="navy" @click="loadAds(true)">
        <v-icon left>mdi-refresh</v-icon>
        Aktualizovat
      </v-btn>
    </div>

    <div class="mb-6 d-flex justify-space-between align-center">
      <v-btn
        medium
        outlined
        elevation="0"
        color="amber"
        class="c-btn"
        @click="onNewAdClick"
      >
        <v-icon left>mdi-plus</v-icon>
        Přidat novou reklamu
      </v-btn>
    </div>

    <v-card elevation="0">
      <div class="d-flex px-4 py-4 mb-4">
        <v-tabs background-color="transparent" class="c-tabs">
          <v-tab v-for="f in filters" :key="f.value" @click="filter = f.value">
            {{ f.text }}
          </v-tab>
        </v-tabs>
        <div style="max-width: 220px" class="ml-auto">
          <v-select outlined dense hide-details :items="views" v-model="view" />
          <v-select
            outlined
            dense
            hide-details
            :items="datePresets"
            v-model="datePreset"
            v-if="view === 'analytic'"
            @input="loadAds(true)"
          />
        </div>
      </div>

      <ads-table :key="view" :filter="filter" :view="view" />
    </v-card>
  </PageLayout>
</template>

<script>
import { call, sync } from "vuex-pathify"

import PageLayout from "@/components/page/home/PageLayout.vue"
import AdsTable from "@/components/ui/ads/AdsTable"
import Toastification from "../../components/ui/Toastification"

const views = [
  { text: "Analytický pohled", value: "analytic" },
  { text: "Obecný pohled", value: "generic" },
]

const filters = [
  { text: "Vše", value: "ALL" },
  { text: "Aktivní", value: "ACTIVE" },
  { text: "Neaktivní", value: "PAUSED" },
  { text: "Rozepsané", value: "DRAFT" },
]

const datePresets = [
  { text: "Maximum", value: "maximum" },
  { text: "Dnes", value: "today" },
  { text: "Včera", value: "yesterday" },
  { text: "Tento měsíc", value: "this_month" },
  { text: "Minulý měsíc", value: "last_month" },
  { text: "Toto čtvrtletí", value: "this_quarter" },
  { text: "Tento rok", value: "this_year" },
  { text: "Poslední 3 dny", value: "last_3d" },
  { text: "Posledních 7 dní", value: "last_7d" },
  { text: "Posledních 14 dní", value: "last_14d" },
  { text: "Posledních 30 dní", value: "last_30d" },
  { text: "Posledních 90 dní", value: "last_90d" },
  { text: "Poslední čtvrletí", value: "last_quarter" },
  { text: "Poslední rok", value: "last_year" },
]
export default {
  name: "AdsIndex",
  components: {
    AdsTable,
    PageLayout,
  },
  data() {
    return {
      filter: "ALL",
      filters,
      view: "generic",
      views,
      datePresets,
    }
  },
  computed: {
    ...sync("ads", ["datePreset"]),
  },
  methods: {
    ...call("ads", ["clearAdModel", "loadAds"]),
    onNewAdClick() {
      this.clearAdModel()
      this.$router.push("/ads/new")
    },
  },
  mounted() {
    if (this.$route.query.success !== undefined) {
      this.$toast.success({
        component: Toastification,
        props: {
          title: "Reklama publikována",
          text: "Vaše reklama byla úspěšně publikována.",
        },
      })
    }
    this.datePreset = "maximum"
    this.loadAds(true)
  },
}
</script>
